import ReferralsActionTypes from './referrals-types'

export const startGetReferrals = data => ({
    type: ReferralsActionTypes.START_GET_REFERRALS,
    payload: data,
})

export const successGetReferrals = data => ({
    type: ReferralsActionTypes.SUCCESS_GET_REFERRALS,
    payload: data,
})

export const finishGetReferrals = data => ({
    type: ReferralsActionTypes.FINISH_GET_REFERRALS,
    payload: data,
})

export const failureGetReferrals = data => ({
    type: ReferralsActionTypes.FAILURE_GET_REFERRALS,
    payload: data,
})

export const startGetReferralsStatus = data => ({
    type: ReferralsActionTypes.START_GET_REFERRALS_STATUS,
    payload: data,
})

export const successGetReferralsStatus = data => ({
    type: ReferralsActionTypes.SUCCESS_GET_REFERRALS_STATUS,
    payload: data,
})

export const finishGetReferralsStatus = data => ({
    type: ReferralsActionTypes.FINISH_GET_REFERRALS_STATUS,
    payload: data,
})

export const failureGetReferralsStatus = data => ({
    type: ReferralsActionTypes.FAILURE_GET_REFERRALS_STATUS,
    payload: data,
})

export const startPostReferralsTraffic = data => ({
    type: ReferralsActionTypes.START_POST_REFERRALS_TRAFFIC,
    payload: data,
})

export const successPostReferralsTraffic = data => ({
    type: ReferralsActionTypes.SUCCESS_POST_REFERRALS_TRAFFIC,
    payload: data,
})

export const finishPostReferralsTraffic = data => ({
    type: ReferralsActionTypes.FINISH_POST_REFERRALS_TRAFFIC,
    payload: data,
})

export const failurePostReferralsTraffic = data => ({
    type: ReferralsActionTypes.FAILURE_POST_REFERRALS_TRAFFIC,
    payload: data,
})
